import Marquee from "react-fast-marquee";
import { Asterisk, Sparkles, Zap, Star } from "lucide-react";

const Sep = ({ Icon = Asterisk, accent = false }) => (
  <Icon
    className={`shrink-0 ${accent ? "text-[var(--accent)]" : "text-zinc-500"}`}
    style={{ width: "1.6em", height: "1.6em" }}
    strokeWidth={1.4}
  />
);

const Item = ({ children, outline = false, accent = false }) => (
  <span
    className={`font-display uppercase tracking-tight whitespace-nowrap pr-10 ${
      outline ? "text-outline" : accent ? "text-[var(--accent)]" : "text-white"
    }`}
    style={{ fontSize: "3.4vw", lineHeight: 0.95 }}
  >
    {children}
  </span>
);

export default function MarqueeSection() {
  return (
    <section
      data-testid="marquee-section"
      className="relative py-10 sm:py-12 border-y border-white/[0.08] bg-black overflow-hidden"
    >
      {/* Edge fades for cinematic look */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 z-10 bg-gradient-to-r from-black to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 z-10 bg-gradient-to-l from-black to-transparent" />

      {/* Row 1 — filled, left → right reads as scrolling left */}
      <Marquee speed={55} gradient={false} pauseOnHover={false} autoFill direction="left">
        <div className="flex items-center pr-10">
          <Item>Agence digitale indépendante</Item>
          <Sep accent />
          <Item outline>Création de sites web sur-mesure</Item>
          <Sep Icon={Sparkles} />
          <Item accent>Design qui convertit</Item>
          <Sep />
          <Item outline>SEO intégré dès la conception</Item>
          <Sep Icon={Star} accent />
        </div>
      </Marquee>

      {/* Row 2 — outline, opposite direction, smaller */}
      <div className="mt-3">
        <Marquee speed={38} gradient={false} pauseOnHover={false} autoFill direction="right">
          <div
            className="flex items-center pr-10 font-mono uppercase tracking-[0.2em] text-zinc-400"
            style={{ fontSize: "0.95rem" }}
          >
            <span className="pr-8">React · Next.js · TypeScript</span>
            <Sep Icon={Zap} accent />
            <span className="pr-8">SEO optimisé pour Google</span>
            <Sep />
            <span className="pr-8">Livraison en 1 à 4 semaines</span>
            <Sep Icon={Asterisk} accent />
            <span className="pr-8">Audit gratuit · Sans engagement</span>
            <Sep />
            <span className="pr-8">Réponse sous 24–48h</span>
            <Sep Icon={Sparkles} accent />
            <span className="pr-8">Mise en ligne de votre site</span>
            <Sep />
            <span className="pr-8">Maintenance & SEO mensuel disponibles</span>
            <Sep Icon={Star} accent />
          </div>
        </Marquee>
      </div>
    </section>
  );
}
